<template>
    <auth-layout>
        <container class="min-h-screen items-center">
            <row class="min-h-screen items-center justify-center">
                <column md="6">
                    <card class="m-0 mt-12 p-6">
                        <c-form @submit.prevent="submit">
                            <h2>
                                {{ trans(`auth.two_factor_challenge.${type}.heading`) }}
                            </h2>
                            <p class="text-muted">
                                {{ trans(`auth.two_factor_challenge.${type}.prompt`) }}
                            </p>
                            <div v-if="!recovery">
                                <jet-input
                                    id="code"
                                    ref="codeInput"
                                    v-model="form.code"
                                    :disabled="form.processing"
                                    :horizontal="false"
                                    :invalid-feedback="form.errors.code"
                                    :placeholder="trans('auth.two_factor_challenge.placeholder.challenge')"
                                    autocomplete="one-time-code"
                                    autofocus
                                    inputmode="numeric"
                                    maxlength="6"
                                    name="code"
                                    pattern="[0-9]{6}"
                                    required
                                    type="text"
                                >
                                    <template #prepend>
                                        <icon icon="cil-user" />
                                    </template>
                                </jet-input>
                            </div>

                            <div v-else>
                                <jet-input
                                    ref="recoveryCodeInput"
                                    v-model="form.recovery_code"
                                    :disabled="form.processing"
                                    :horizontal="false"
                                    :invalid-feedback="form.errors.recovery_code"
                                    :placeholder="trans('auth.two_factor_challenge.placeholder.recovery_code')"
                                    autocomplete="one-time-code"
                                    autofocus
                                    inputmode="numeric"
                                    required
                                    type="text"
                                >
                                    <template #prepend>
                                        <icon icon="cil-user" />
                                    </template>
                                </jet-input>
                            </div>
                            <div class="flex flex-wrap justify-between">
                                <jet-button class="mb-2" color="secondary" type="button" @click.prevent="toggleRecovery">
                                    {{ trans(`auth.two_factor_challenge.action.${type}`) }}
                                </jet-button>
                                <jet-button :disabled="form.processing" class="mb-2 px-6" color="primary" type="submit"
                                    >{{ trans('auth.two_factor_challenge.action.submit') }}
                                </jet-button>
                            </div>
                        </c-form>
                    </card>
                </column>
            </row>
        </container>
    </auth-layout>
</template>

<script setup>
import { computed, nextTick, ref, watch } from 'vue';
import { useForm } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { trans } from '@/mixins/i18n.js';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import AuthLayout from '@/Layouts/AuthLayout.vue';
import Container from '@/Components/Container.vue';
import Row from '@/Components/Row.vue';
import Card from '@/Components/Card.vue';

const recovery = ref(false);
const codeInput = ref(null);
const recoveryCodeInput = ref(null);

const form = useForm({
    code: '',
    recovery_code: '',
});

const type = computed(() => (recovery.value ? 'recovery_code' : 'challenge'));

const submit = () => {
    form.post(route('two-factor.login'));
};

const toggleRecovery = () => {
    recovery.value = !recovery.value;

    nextTick(() => {
        if (recovery.value) {
            form.code = '';
            recoveryCodeInput.value?.focus();
        } else {
            form.recovery_code = '';
            codeInput.value?.focus();
        }
    });
};

watch(
    () => form.code,
    (value) => {
        if (!recovery.value && /^\d{6}$/.test(value) && !form.processing) {
            submit();
        }
    },
);
</script>
